import { ActionType, matcher, MatchType } from "@cdv/jazz-ui";
import { Resource } from "../utils";
import CardShow from "./CardShow";

export default matcher({ resource: Resource.TestVersion })
  .set(MatchType.View, CardShow, { action: ActionType.SHOW })
  .entries();
